import { render } from "./AgencySlotsPerValue.vue?vue&type=template&id=627c3a6a&scoped=true"
import script from "./AgencySlotsPerValue.vue?vue&type=script&lang=js"
export * from "./AgencySlotsPerValue.vue?vue&type=script&lang=js"

import "./AgencySlotsPerValue.vue?vue&type=style&index=0&id=627c3a6a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-627c3a6a"]])

export default __exports__